import React, {useEffect, useRef, useState} from "react";

import {useTranslation} from "react-i18next";
import {useNavigate, useParams} from "react-router-dom";
import AgentScheduleNew from "./AgentScheduleNew";
import Loading from "../../../components/Loading/Loading";
import { agentScheduleService } from "../../../services/agentScheduleService";

function AgentScheduleEdit() {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        initialDate: "",
        endDate: "",
        creationDate: "",
        observations: "",
        timeSlots: []
    });

    const mapDayNumberToLabel = (dayNumber) => {
        const dayMap = {
            1: "MONDAY",
            2: "TUESDAY",
            3: "WEDNESDAY",
            4: "THURSDAY",
            5: "FRIDAY",
            6: "SATURDAY",
            7: "SUNDAY"
        };
        return dayMap[dayNumber] || "";
    };

    useEffect(() => {
        if (id) {
            agentScheduleService.find(+id)
                .then((agentScheduleDetails) => {
                    const mappedTimeSlots = agentScheduleDetails.workhours?.map(hour => ({
                        id: hour.id,
                        id_agente: hour.id_agente,
                        id_escala_agente: hour.id_escala_agente,
                        dia_semana_inicio: mapDayNumberToLabel(hour.dia_semana_inicio),
                        dia_semana_fim: mapDayNumberToLabel(hour.dia_semana_fim),
                        hora_inicio: hour.hora_inicio,
                        hora_fim: hour.hora_fim
                    })) || [];

                    setFormData({
                        id: agentScheduleDetails.id,
                        name: agentScheduleDetails.nome,
                        initialDate: agentScheduleDetails.data_inicial,
                        endDate: agentScheduleDetails.data_final,
                        creationDate: agentScheduleDetails.data_criacao,
                        observations: agentScheduleDetails.observacoes,
                        timeSlots: mappedTimeSlots
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
    }, [id]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <AgentScheduleNew data={formData} />
            )}
        </>
    );
}

export default AgentScheduleEdit;
